export default {

  namespaced: true,

  state: () => ({

    // print_layout: null

  }),

  mutations: {


  },
  getters: {
    getPrintLayout(state, getters) {
      return localStorage.getItem('print_layout').replace(/"/g, "");; //para remover a (")

    }
  },

  actions: {
    setPrintLayout({ dispatch, commit }, layout) {
      localStorage.setItem("print_layout", JSON.stringify(layout));
    }
  }
}
